<!--评论-->
<template>
  <div>
    <div class="con">
      <oil-template v-for="(val,key) in stay" :key="key" :data="val"></oil-template>
    </div>
    <div style="padding: 0 10px;">
      <van-field v-model="message" rows="1" autosize type="textarea" size="large" placeholder="宝贝满足你的期待吗？说说你的使用心得，分享给想买的他们吧" class="text_box"/>
    </div>
     <van-row gutter="20" class="issue_head">
      <van-col span="5">服务态度</van-col>
      <van-col span="19"><van-rate v-model="value" allow-half void-icon="star" void-color="#eee"/></van-col>
      <van-col span="5">油站评价</van-col>
      <van-col span="19"><van-rate v-model="value1" allow-half void-icon="star" void-color="#eee" /></van-col>
    </van-row>
    <div style="padding: 10px;"><van-button type="info" block native-type="submit" style="border-radius: 20px;">发布</van-button></div>
  </div>
</template>

<style lang="scss" scoped>
.con {
  padding: 10px;
  height: 120px;
  background: #fff;
}

.issue_head {
  margin-top: 20px;
  background: #fff;
  padding:0  10px;
  line-height: 30px;

  .issue {
    height: 30px;
    margin-top:10px;

    span {
      display: inline-block;
      position: relative;
      top:3px;
    }
  }
  .nut-rate {
    display: inline-block;
    margin-left: 20px;
  }
}
.text_box{
  width:100%;
  height:210px;
  border:0.5px solid #ccc;
  border-radius: 10px;
}
.popup_box {
  height: calc(100vh);
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #f6f6f6;
  touch-action: pan-y !important;
}
</style>

<script>
import oilTemplate from '@/components/site/site_template'
export default {
  name: 'components',
  components: {oilTemplate},
  data () {
    return {
      value: 1,
      value1: 1,
      data: [],
      message: '',
      stay: [
        {
          km: 11,
          msg: {
            image: {
              url: 'http://maximum_api.bei-lin.cn/files/121_1593607611_893.jpg'
            },
            show_pho: '0760-86694266',
            add: '珠海市香州区敬业路'
          },
          name: '珠海贝林测试',
          score: {
            score: 5,
            star: 5
          }
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stay/comments.vue